<template lang="pug">
  .container
    .info
      img.banner(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/success.png")
      p 恭喜！办理成功
    .ad
      p.color-red.font-big(style="margin-bottom: .4rem;") 限时活动
      p.point 进入“冰蓝流量”公众号领取视频会员权益！
      p.color-red.font-big 截图保存下方二维码，进入公众号
      img.bl(src="https://tlhw.oss-cn-shanghai.aliyuncs.com/vxpage/shaanxi/bl.png")
      p.color-red.font-big 微信扫一扫关注公众号“冰蓝流量”
      el-button.btn-copy(@click="copyBLName", ref="blAccount") 一键复制微信号
      div(ref="blAccount", style="opacity: 0;") {{blAccount}}
    .rule
      .title - 领取规则 -
      .content 客户办理成功之后且不退订业务，即可每月领取一次会员权益，客户需主动关注微信公众号“冰蓝流量”输入“宁夏移动”进入权益领取界面领取，权益自选择之日起，30个自然日内有效，各大权益平台有效期不相同，以实际权益提供方显示有效期为准。若用户退订了本业务，则次月不再享有视频会员领取资格。
</template>

<script>
export default {
  data() {
    return {
      shareNoticeVisiable: false,
      blAccount: 'meirxx'
    }
  },
  methods: {
    copyBLName() {
      let _range = document.createRange()
      _range.selectNode(this.$refs.blAccount)
      window.getSelection().removeAllRanges();
      window.getSelection().addRange(_range);
      document.execCommand('Copy')
      window.getSelection().removeAllRanges()
    }
  }
}
</script>

<style lang="less" scoped>
.info{
  font-size: 1.1rem;
  text-align: center;
  margin-top: 4rem;
  .banner{
    width: 64px;
    height: 64px;
  }
}
.color-red{
  color: Red;
}
.font-big{
  font-weight: bold;
}
.ad{
  margin-top: 1rem;
  text-align: center;
  padding: 0 1rem;
  .bl{
    width: 100%;
  }
}
.btn-copy{
  color: #fff;
  background-color: red;
  border: 0;
  margin-top: .5rem;
}
.point{
  margin: .5rem 0;
  border: 2px dashed #d3d3d3;
  padding: .2rem;
}
.rule{
  width: 80%;
  margin: 0 auto;
  border: 1px solid #a3a3a3;
  padding: 1rem;
  border-radius: 6px;
  .title{
    text-align: center;
  }
  .content{
    margin-top: .5rem;
    font-size: .8rem;
    text-align: left;
    text-indent: 1rem;
    color: #787878;
  }
}
</style>